class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.setAnnouncementHeight(Math.round(this.getBoundingClientRect().height));

    this.observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      const height = Math.round(entry?.contentRect?.height || this.getBoundingClientRect().height);
      this.setAnnouncementHeight(height);
    });
    this.observer.observe(this);
  }

  setAnnouncementHeight(height) {
    document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
  }
}
customElements.define('announcement-bar', AnnouncementBar);
